/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { ApiConstant } from './api.constant';
import * as CryptoJS from 'crypto-js';
@Injectable()
export class HttpManagerService {
    user: any;
    private baseurl2: String;
    private isSecurity: boolean = true;
    private crypto_password: String;
    private headers: Headers;
    private options: RequestOptions;
    private baseurl: String;
    constructor(
        private apiservice: ApiConstant,
        private http: Http
    ) {
        this.baseurl = apiservice.ServerWithApiUrl;
        this.baseurl2 = apiservice.ServerWithApiUrlreplace;
        this.crypto_password = apiservice.crypto_password;
    }
    requestAuthentication() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('X-Authorization', localStorage.getItem('id_token'));
        this.options = new RequestOptions({ headers: this.headers });
    }
    HttpPostreplace(api, data, param): Promise<any> {
        this.requestAuthentication();
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl2 + api + _params;
        var ciphertext = CryptoJS.AES.encrypt(data.toString(), this.crypto_password);
        var JsonRequest = {
            data: ciphertext.toString()
        }
        return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
            var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(plaintext) as any
        }).catch(this.handleError);
    }
    HttpPost(api, data, param): Promise<any> {
        this.requestAuthentication();
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        var ciphertext = CryptoJS.AES.encrypt(data.toString(), this.crypto_password);
        var JsonRequest = {
            data: ciphertext.toString()
        }
        return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
            var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(plaintext) as any
        }).catch(this.handleError);
    }
    HttpPost2(api, data, param): Promise<any> {
        this.requestAuthentication();
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl2 + api + _params;
        var ciphertext = CryptoJS.AES.encrypt(data.toString(), this.crypto_password);
        var JsonRequest = {
            data: ciphertext.toString()
        }
        return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
            var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(plaintext) as any
        }).catch(this.handleError);
    }
    HttpPut(api, data, param): Promise<any> {
        this.requestAuthentication();
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        var ciphertext = CryptoJS.AES.encrypt(data.toString(), this.crypto_password);
        var JsonRequest = {
            data: ciphertext.toString()
        }
        return this.http.put(finalAPI, JsonRequest, this.options).toPromise().then(res => {
            var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(plaintext) as any
        }).catch(this.handleError);
    }
    HttpGet(api, param): Promise<any> {
        this.requestAuthentication();
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        return this.http.get(finalAPI, this.options).toPromise().then(res => {
            var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(plaintext) as any
        }).catch(this.handleError);
    }
    HttpDelete(api, param): Promise<any> {
        this.requestAuthentication();
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        return this.http.delete(finalAPI, this.options).toPromise().then(res => {
            var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(plaintext) as any
        }).catch(this.handleError);
    }
    HttpPostImageId(api, data, file, param): Promise<any> {
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        var ciphertext = CryptoJS.AES.encrypt(data.toString(), this.crypto_password);
        const fd = new FormData();
        if (file == undefined || file == "" || file == null) {

        } else {
            fd.append('datafile', file, file.name);
        }
        fd.append('data', ciphertext.toString())
        var headers1 = new Headers();
        headers1.append('X-Authorization', localStorage.getItem('id_token'));
        var options1 = new RequestOptions({ headers: headers1 });
        return this.http.post(finalAPI, fd, options1).toPromise().then(res => {
            var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(plaintext) as any

        }).catch(this.handleError);
    }
    HttpPostlogoImage(api, name, image, is_form_data, param): Promise<any> {
        let headers1 = new Headers();
        headers1.append('X-Authorization', localStorage.getItem('id_token'));
        let opt = new RequestOptions({ headers: headers1 });
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        if (this.isSecurity) {
            if (is_form_data == true) {
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                const fd = new FormData();
                fd.append('logo', image, image.name);
                fd.append('data', ciphertext.toString())
                return this.http.post(finalAPI, fd, opt).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            } else {
                this.requestAuthentication();
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                var JsonRequest = {
                    data: ciphertext.toString()
                }
                return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            }
        }
        else {
            var JsonRequest1 =
            {
                data: name
            }
            return this.http.post(finalAPI, JsonRequest1, this.options).toPromise().then(res => {
                return res.json().data.toString() as any
            }).catch(this.handleError);
        }
    }
    HttpPostsinglesliderImage(api, name, image, is_form_data, param): Promise<any> {
        let headers1 = new Headers();
        headers1.append('X-Authorization', localStorage.getItem('id_token'));
        let opt = new RequestOptions({ headers: headers1 });
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        if (this.isSecurity) {
            if (is_form_data == true) {
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                const fd = new FormData();
                fd.append('slider_image', image, image.name);
                fd.append('data', ciphertext.toString())
                return this.http.post(finalAPI, fd, opt).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            } else {
                this.requestAuthentication();
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                var JsonRequest = {
                    data: ciphertext.toString()
                }
                return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            }
        }
        else {
            var JsonRequest1 =
            {
                data: name
            }
            return this.http.post(finalAPI, JsonRequest1, this.options).toPromise().then(res => {
                return res.json().data.toString() as any
            }).catch(this.handleError);
        }
    }
    HttpPostbannerImage(api, name, image, is_form_data, param): Promise<any> {
        let headers1 = new Headers();
        headers1.append('X-Authorization', localStorage.getItem('id_token'));
        let opt = new RequestOptions({ headers: headers1 });
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        if (this.isSecurity) {
            if (is_form_data == true) {
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                const fd = new FormData();
                fd.append('banner', image, image.name);
                fd.append('data', ciphertext.toString())
                return this.http.post(finalAPI, fd, opt).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            } else {
                this.requestAuthentication();
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                var JsonRequest = {
                    data: ciphertext.toString()
                }
                return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            }
        }
        else {
            var JsonRequest1 =
            {
                data: name
            }
            return this.http.post(finalAPI, JsonRequest1, this.options).toPromise().then(res => {
                return res.json().data.toString() as any
            }).catch(this.handleError);
        }
    }
    HttpPostHeadersliderImage(api, name, image, is_form_data, param): Promise<any> {
        let headers1 = new Headers();
        headers1.append('X-Authorization', localStorage.getItem('id_token'));
        let opt = new RequestOptions({ headers: headers1 });
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        if (this.isSecurity) {
            if (is_form_data == true) {
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                const fd = new FormData();
                fd.append('header_slider_image', image, image.name);
                fd.append('data', ciphertext.toString())
                return this.http.post(finalAPI, fd, opt).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            } else {
                this.requestAuthentication();
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                var JsonRequest = {
                    data: ciphertext.toString()
                }
                return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            }
        }
        else {
            var JsonRequest1 =
            {
                data: name
            }
            return this.http.post(finalAPI, JsonRequest1, this.options).toPromise().then(res => {
                return res.json().data.toString() as any
            }).catch(this.handleError);
        }
    }
    HttpPostseoImage(api, name, image, is_form_data, param): Promise<any> {
        let headers1 = new Headers();
        headers1.append('X-Authorization', localStorage.getItem('id_token'));
        let opt = new RequestOptions({ headers: headers1 });
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        if (this.isSecurity) {
            if (is_form_data == true) {
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                const fd = new FormData();
                fd.append('SEOimage', image, image.name);
                fd.append('data', ciphertext.toString())
                return this.http.post(finalAPI, fd, opt).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            } else {
                this.requestAuthentication();
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                var JsonRequest = {
                    data: ciphertext.toString()
                }
                return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            }
        }
        else {
            var JsonRequest1 =
            {
                data: name
            }
            return this.http.post(finalAPI, JsonRequest1, this.options).toPromise().then(res => {
                return res.json().data.toString() as any
            }).catch(this.handleError);
        }
    }
    HttpPostfeatureImage(api, name, image, is_form_data, param): Promise<any> {
        let headers1 = new Headers();
        headers1.append('X-Authorization', localStorage.getItem('id_token'));
        let opt = new RequestOptions({ headers: headers1 });
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        if (this.isSecurity) {
            if (is_form_data == true) {
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                const fd = new FormData();
                fd.append('featureimage', image, image.name);
                fd.append('data', ciphertext.toString())
                return this.http.post(finalAPI, fd, opt).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            } else {
                this.requestAuthentication();
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                var JsonRequest = {
                    data: ciphertext.toString()
                }
                return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            }
        }
        else {
            var JsonRequest1 =
            {
                data: name
            }
            return this.http.post(finalAPI, JsonRequest1, this.options).toPromise().then(res => {
                return res.json().data.toString() as any
            }).catch(this.handleError);
        }
    }
    HttpPostsliderImage(api, name, image, is_form_data, param): Promise<any> {
        let headers1 = new Headers();
        headers1.append('X-Authorization', localStorage.getItem('id_token'));
        let opt = new RequestOptions({ headers: headers1 });
        var _params = "";
        if (param != "") {
            _params = "/" + param;
        }
        var finalAPI = this.baseurl + api + _params;
        if (this.isSecurity) {
            if (is_form_data == true) {
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                const fd = new FormData();
                for (var i = 0; i < image.length; i++) {
                    fd.append('slider_image', image[i], image[i]['name']);
                }
                fd.append('data', ciphertext.toString())
                return this.http.post(finalAPI, fd, opt).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any

                }).catch(this.handleError);
            } else {
                this.requestAuthentication();
                var ciphertext = CryptoJS.AES.encrypt(name.toString(), this.crypto_password);
                var JsonRequest = {
                    data: ciphertext.toString()
                }
                return this.http.post(finalAPI, JsonRequest, this.options).toPromise().then(res => {
                    var bytes = CryptoJS.AES.decrypt(res.json().data.toString(), this.crypto_password);
                    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                    return JSON.parse(plaintext) as any
                }).catch(this.handleError);
            }
        }
        else {
            var JsonRequest1 =
            {
                data: name
            }
            return this.http.post(finalAPI, JsonRequest1, this.options).toPromise().then(res => {
                return res.json().data.toString() as any
            }).catch(this.handleError);
        }
    }
    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/httpmanager.service.ts